export default function() {
  if( typeof pageYOffset != 'undefined' ){
      return pageYOffset;
  } else {
      var B = document.body; //IE 'quirks'
      var D = document.documentElement; //IE with doctype
      D = (D.clientHeight)? D: B;
      return D.scrollTop;
  }
}



// WEBPACK FOOTER //
// ./scripts/util/scrollTop.js